module.exports = __webpack_public_path__ + "img/AR.28a2eb88.svg";